
          <!--Formulario excepcional-->
          <form [formGroup]="formUploadUsers" class="content-form" (ngSubmit)="sendUploadUserInformation()">
            <div class="row">
              <!-- Tipo de documento -->
              <div class="col-md-6 col-12 mb-3">
                <div class="form-group">
                  <label for="documentType" class="form-label fuenteGeneral">Tipo de Documento</label>
                  <select formControlName="documentType" class="form-select"
                    [ngClass]="{'is-invalid': formUploadUsers.get('documentType').invalid && formUploadUsers.get('documentType').touched}">
                    <option [ngValue]="null">-- SELECCIONE --</option>
                    <option *ngFor="let documentType of documentTypes" [ngValue]="documentType">
                      {{ documentType.type }}
                    </option>
                  </select>
                  <div *ngIf="formUploadUsers.get('documentType').invalid && formUploadUsers.get('documentType').touched" class="invalid-feedback">
                    <small>Este campo es obligatorio.</small>
                  </div>
                </div>
              </div>

              <!-- Número de documento -->
              <div class="col-md-6 col-12 mb-3">
                <div class="form-group">
                  <label for="documentNumber" class="form-label fuenteGeneral">Número de Documento</label>
                  <input 
                    matInput 
                    maxlength="20" 
                    formControlName="documentNumber" 
                    class="form-control"
                    placeholder="Ingrese su número de documento"
                    (keypress)="validateDocNumberInput($event)"
                    [ngClass]="{
                      'is-invalid': formUploadUsers.get('documentNumber')?.invalid && formUploadUsers.get('documentNumber')?.touched
                    }">

                  <div *ngIf="formUploadUsers.get('documentNumber').invalid && formUploadUsers.get('documentNumber').touched" class="invalid-feedback">
                    <!--<small>Este campo es obligatorio y debe ser válido.</small>-->
                    <small *ngIf="formUploadUsers.get('documentNumber')?.errors?.['required']">
                      Este campo es obligatorio.
                    </small>
                    <small *ngIf="formUploadUsers.get('documentNumber')?.errors?.['pattern']">
                      El formato del número de documento es inválido.
                    </small>
                  </div>
                </div>
              </div>

              <!-- Nombre -->
              <div class="col-md-6 col-12 mb-3">
                <div class="form-group">
                  <label for="name" class="form-label fuenteGeneral">Nombre</label>
                  <input matInput maxlength="50" formControlName="name" class="form-control"
                    placeholder="Ingrese su nombre"
                    [ngClass]="{'is-invalid': formUploadUsers.get('name').invalid && formUploadUsers.get('name').touched}">
                  <div *ngIf="formUploadUsers.get('name').invalid && formUploadUsers.get('name').touched" class="invalid-feedback">
                    <small>Este campo es obligatorio.</small>
                  </div>
                </div>
              </div>

              <!-- Apellido Paterno-->
              <div class="col-md-6 col-12 mb-3">
                <div class="form-group">
                  <label for="lastname" class="form-label fuenteGeneral">Apellido Paterno</label>
                  <input matInput maxlength="50" formControlName="lastname" class="form-control"
                    placeholder="Ingrese su apellido paterno"
                    [ngClass]="{'is-invalid': formUploadUsers.get('lastname').invalid && formUploadUsers.get('lastname').touched}">
                  <div *ngIf="formUploadUsers.get('lastname').invalid && formUploadUsers.get('lastname').touched" class="invalid-feedback">
                    <small>Este campo es obligatorio.</small>
                  </div>
                </div>
              </div>

              <!-- Apellido Materno-->
              <div class="col-md-6 col-12 mb-3">
                <div class="form-group">
                  <label for="maternalLastname" class="form-label fuenteGeneral">Apellido Materno</label>
                  <input matInput maxlength="50" formControlName="maternalLastname" class="form-control"
                    placeholder="Ingrese su apellido materno"
                    [ngClass]="{'is-invalid': formUploadUsers.get('maternalLastname').invalid && formUploadUsers.get('maternalLastname').touched}">
                  <div *ngIf="formUploadUsers.get('maternalLastname').invalid && formUploadUsers.get('maternalLastname').touched" class="invalid-feedback">
                    <small>Este campo es obligatorio.</small>
                  </div>
                </div>
              </div>

              <!-- Correo Electrónico -->
              <div class="col-md-6 col-12 mb-3">
                <div class="form-group">
                  <label for="email" class="form-label fuenteGeneral">Correo Electrónico</label>
                  <input matInput type="email" formControlName="email" class="form-control"
                    placeholder="Ingrese su correo electrónico"
                    [ngClass]="{'is-invalid': formUploadUsers.get('email').invalid && formUploadUsers.get('email').touched}">
                  <div *ngIf="formUploadUsers.get('email').invalid && formUploadUsers.get('email').touched" class="invalid-feedback">
                    <small *ngIf="formUploadUsers.get('email')?.errors?.['required']">
                      Este campo es obligatorio.
                    </small>
                    <small *ngIf="formUploadUsers.get('email')?.errors?.['pattern']">
                      El correo debe tener un formato correcto
                    </small>
                  </div>
                </div>
              </div>

              <!-- INFORMACION DEL DESTINATARIO -->

              <h5 class="my-4 text-primary">Información del destinatario</h5>

              <!-- Nombre -->
              <div class="col-md-6 col-12 mb-3">
                <div class="form-group">
                  <label for="nameDestinatary" class="form-label fuenteGeneral text-primary">Nombre del destinatario</label>
                  <input matInput maxlength="50" formControlName="nameDestinatary" class="form-control"
                    placeholder="Ingrese nombre del destinatario"
                    [ngClass]="{'is-invalid': formUploadUsers.get('nameDestinatary').invalid && formUploadUsers.get('nameDestinatary').touched}">
                  <div *ngIf="formUploadUsers.get('nameDestinatary').invalid && formUploadUsers.get('nameDestinatary').touched" class="invalid-feedback">
                    <small>Este campo es obligatorio.</small>
                  </div>
                </div>
              </div>

              <!-- Apellido Paterno-->
              <div class="col-md-6 col-12 mb-3">
                <div class="form-group">
                  <label for="lastnameDestinatary" class="form-label fuenteGeneral text-primary">Apellido Paterno del destinatario</label>
                  <input matInput maxlength="50" formControlName="lastnameDestinatary" class="form-control"
                    placeholder="Ingrese su apellido paterno"
                    [ngClass]="{'is-invalid': formUploadUsers.get('lastnameDestinatary').invalid && formUploadUsers.get('lastnameDestinatary').touched}">
                  <div *ngIf="formUploadUsers.get('lastnameDestinatary').invalid && formUploadUsers.get('lastnameDestinatary').touched" class="invalid-feedback">
                    <small>Este campo es obligatorio.</small>
                  </div>
                </div>
              </div>

              <!-- Apellido Materno-->
              <div class="col-md-6 col-12 mb-3">
                <div class="form-group">
                  <label for="maternalLastnameDestinatary" class="form-label fuenteGeneral text-primary">Apellido Materno del destinatario</label>
                  <input matInput maxlength="50" formControlName="maternalLastnameDestinatary" class="form-control"
                    placeholder="Ingrese su apellido materno"
                    [ngClass]="{'is-invalid': formUploadUsers.get('maternalLastnameDestinatary').invalid && formUploadUsers.get('maternalLastnameDestinatary').touched}">
                  <div *ngIf="formUploadUsers.get('maternalLastnameDestinatary').invalid && formUploadUsers.get('maternalLastnameDestinatary').touched" class="invalid-feedback">
                    <small>Este campo es obligatorio.</small>
                  </div>
                </div>
              </div>

              <!-- Tipo de documento -->
              <div class="col-md-6 col-12 mb-3">
                <div class="form-group">
                  <label for="documentTypeDestinatary" class="form-label fuenteGeneral text-primary">Tipo de Documento del destinatario</label>
                  <select formControlName="documentTypeDestinatary" class="form-select"
                    [ngClass]="{'is-invalid': formUploadUsers.get('documentTypeDestinatary').invalid && formUploadUsers.get('documentTypeDestinatary').touched}">
                    <option [ngValue]="null">-- SELECCIONE --</option>
                    <option *ngFor="let documentType of documentTypes" [ngValue]="documentType">
                      {{ documentType.type }}
                    </option>
                  </select>
                  <div *ngIf="formUploadUsers.get('documentTypeDestinatary').invalid && formUploadUsers.get('documentTypeDestinatary').touched" class="invalid-feedback">
                    <small>Este campo es obligatorio.</small>
                  </div>
                </div>
              </div>

              <!-- Número de documento -->
              <div class="col-md-6 col-12 mb-3">
                <div class="form-group">
                  <label for="documentNumberDestinatary" class="form-label fuenteGeneral text-primary">Número de Documento del destinatario</label>
                  <input 
                    matInput 
                    maxlength="20" 
                    formControlName="documentNumberDestinatary" 
                    class="form-control"
                    placeholder="Ingrese su número de documento"
                    (keypress)="validateDocNumberInput($event)"
                    [ngClass]="{
                      'is-invalid': formUploadUsers.get('documentNumberDestinatary')?.invalid && formUploadUsers.get('documentNumberDestinatary')?.touched
                    }">
                  <div *ngIf="formUploadUsers.get('documentNumberDestinatary').invalid && formUploadUsers.get('documentNumberDestinatary').touched" class="invalid-feedback">
                    <!--<small>Este campo es obligatorio y debe ser válido.</small>-->
                    <small *ngIf="formUploadUsers.get('documentNumberDestinatary')?.errors?.['required']">
                      Este campo es obligatorio.
                    </small>
                    <small *ngIf="formUploadUsers.get('documentNumberDestinatary')?.errors?.['pattern']">
                      El formato del número de documento es inválido.
                    </small>
                  </div>
                </div>
              </div>

               <!-- Tipo de cuenta bancaria -->
               <div class="col-md-6 col-12 mb-3">
                <div class="form-group">
                  <label for="accountType" class="form-label fuenteGeneral text-primary">Tipo de Cuenta Bancaria del destinatario</label>
                  <select formControlName="accountType" class="form-select"
                    [ngClass]="{'is-invalid': formUploadUsers.get('accountType').invalid && formUploadUsers.get('accountType').touched}">
                    <option [ngValue]="null">-- SELECCIONE --</option>
                    <option *ngFor="let accountType of bankAccountTypes" [value]="accountType.id">
                      {{ accountType.typeES }}
                    </option>
                  </select>
                  <div *ngIf="formUploadUsers.get('accountType').invalid && formUploadUsers.get('accountType').touched" class="invalid-feedback">
                    <small>Este campo es obligatorio.</small>
                  </div>
                </div>
              </div>

              <!-- Nombre del Banco -->
              <div class="col-md-6 col-12 mb-3">
                <div class="form-group">
                  <label for="bankName" class="form-label fuenteGeneral text-primary">Nombre del Banco del destinatario</label>
                  <select formControlName="bankName" class="form-select"
                    [ngClass]="{'is-invalid': formUploadUsers.get('bankName').invalid && formUploadUsers.get('bankName').touched}">
                    <option [ngValue]="null">-- SELECCIONE --</option>
                    <option *ngFor="let bankName of banks" [value]="bankName.id">
                      {{ bankName.name }}
                    </option>
                  </select>
                  <div *ngIf="formUploadUsers.get('bankName').invalid && formUploadUsers.get('bankName').touched" class="invalid-feedback">
                    <small>Este campo es obligatorio.</small>
                  </div>
                </div>
              </div>

              <!-- Código de Cuenta Interbancario (CCI) -->
              <div class="col-md-6 col-12 mb-3">
                <div class="form-group">
                  <label for="cci" class="form-label fuenteGeneral text-primary">
                    Código de Cuenta Interbancario (CCI) del destinatario
                    @for(popover of SvgPopover;track popover){
                      <spk-spkpopovers [class]="popover.color" [popoverClass]="popover.class" [popoverContext]="popover.color"
                          [ngbPopover]="popover.content" [innerHTML]="getSanitizedSVG(popover.svg)"></spk-spkpopovers>
                      }
                  </label>
                  <input matInput maxlength="25" formControlName="cci" class="form-control"
                    placeholder="Ingrese el CCI"
                    [ngClass]="{'is-invalid': formUploadUsers.get('cci').invalid && formUploadUsers.get('cci').touched}">
                  <div *ngIf="formUploadUsers.get('cci').invalid && formUploadUsers.get('cci').touched" class="invalid-feedback">
                    <small *ngIf="formUploadUsers.get('cci')?.errors?.['required']">
                      Este campo es obligatorio.
                    </small>
                    <small *ngIf="formUploadUsers.get('cci')?.errors?.['pattern']">
                      El CCI debe tener ser numérico y poseer una longitud exacta de 20
                    </small>
                  </div>
                </div>
              </div>

              
                  <!-- Telefono -->
                  <!-- Fila para celular + botón OTP -->
                <div class="row">
                  <!-- Número de celular -->
                  <div class="col-md-4 col-8 mb-3">
                    <div class="form-group">
                      <label for="numberPhoneUserOTP" class="form-label fuenteGeneral text-primary">Número de celular</label>
                      <input matInput type="tel" maxlength="9" formControlName="numberPhoneUserOTP" class="form-control"
                        placeholder="Ingrese el número de celular" (keypress)="onlyNumberKey($event)"
                        [ngClass]="{'is-invalid': formUploadUsers.get('numberPhoneUserOTP').invalid && formUploadUsers.get('numberPhoneUserOTP').touched}">
                      <div *ngIf="formUploadUsers.get('numberPhoneUserOTP').invalid && formUploadUsers.get('numberPhoneUserOTP').touched" class="invalid-feedback">
                        <small *ngIf="formUploadUsers.get('numberPhoneUserOTP')?.errors?.['pattern']">
                          Debe contener exactamente 9 dígitos numéricos.
                        </small>
                      </div>
                    </div>
                  </div>

                  <!-- Botón de Enviar código OTP -->
                  <div class="col-md-4 col-8 mb-3 d-flex align-items-end">
                    <button type="button" class="btn btn-secondary w-auto" (click)="generateOtp()" [disabled]="formUploadUsers.get('numberPhoneUserOTP').invalid">Enviar código OTP</button>
                  </div>
                  </div>

                  <div class="col-md-6 col-12 mb-3">
                    <div class = "form-check"> 
                        <label class="text-primary">
                          <input 
                            type="checkbox" 
                            class="form-check-input" 
                            formControlName="otpIsValidate" 
                            style="pointer-events: none;" 
                          />
                            Código Verificado
                        </label>
                    </div>
                  </div>
                
                  <div class="row">
                  <div class="col-md-6 col-12 mb-3">
                    <div class = "form-check"> 
                      <label class="text-primary">
                        <input type="checkbox" class="form-check-input" formControlName="isAuthorized" />
                        <u>Confirmo y autorizo el depósito del abono a favor del destinatario registrado.</u>
                      </label>


                      <div *ngIf="formUploadUsers.get('isAuthorized').invalid && formUploadUsers.get('isAuthorized').touched" class="invalid-feedback">
                          <small>
                            *Debe autorizar para poder enviar la información.
                          </small>
                      </div>
                      </div>
                    </div>
                  </div>
              

              <!-- Botón de Enviar -->
              <div class="col-12 text-center mt-2">
                <button type="submit" class="btn btn-primary" [disabled]="formUploadUsers.invalid">Enviar Información</button>
              </div>

            </div>
          </form>
